/**
 * Job Funnel - Simple Vanilla JavaScript Implementation
 */
document.addEventListener( 'DOMContentLoaded', function () {
		const funnels = document.querySelectorAll( '.wp-block-ifdigital-if-job-funnel' );
	console.log( 'Job Funnel: Found ' + funnels.length + ' funnels', funnels );

	funnels.forEach( function ( funnel ) {
		const questionsData = JSON.parse( funnel.dataset.questions );
		const evaluation = JSON.parse( funnel.dataset.evaluation );
		const jobTitle = funnel.dataset.jobTitle;
		const formId = funnel.dataset.formId;
		const formNounce = funnel.dataset.formNounce;

		let currentQuestionIndex = 0;
		const answers = {};

		const questionContainer = funnel.querySelector( '.if-job-funnel__question' );
		const resultContainer = funnel.querySelector( '.if-job-funnel__result' );

		function renderQuestion() {
			const question = questionsData[ currentQuestionIndex ];
			
			let html = `
				<p class="if-job-funnel__question-text">
					<strong>${ question.questionText }</strong>
				</p>
				<div class="if-job-funnel__answers">
			`;

			question.answers.forEach( function ( answer, index ) {
				const isChecked = answers[ question.id ] === index ? 'checked' : '';
				html += `
					<label class="if-job-funnel__answer">
						<input 
							type="radio" 
							name="question-${ question.id }" 
							value="${ index }"
							${ isChecked }
						/>
						<figure class="if-job-funnel__answer-icon">
							<span>${ answer.icon }</span>
						</figure>
						<p class="if-job-funnel__answer-text">${ answer.text }</p>
					</label>
				`;
			} );

			html += `
				</div>
				<div class="if-job-funnel__navigation">
					<button class="if-job-funnel__next-btn btn btn-primary" disabled>
						Nächste Frage
					</button>
				</div>
			`;

			questionContainer.innerHTML = html;

			// Add event listeners
			const radioButtons = questionContainer.querySelectorAll( 'input[type="radio"]' );
			const nextButton = questionContainer.querySelector( '.if-job-funnel__next-btn' );

			radioButtons.forEach( function ( radio ) {
				radio.addEventListener( 'change', function () {
					answers[ question.id ] = parseInt( this.value );
					nextButton.disabled = false;
				} );
			} );

			nextButton.addEventListener( 'click', function () {
				if ( currentQuestionIndex < questionsData.length - 1 ) {
					currentQuestionIndex++;
					renderQuestion();
				} else {
					showResult();
				}
			} );
		}

		function calculateScore() {
			let totalScore = 0;
			let answersSummary = '';

			questionsData.forEach( function ( question ) {
				if ( answers.hasOwnProperty( question.id ) ) {
					const answerIndex = answers[ question.id ];
					const selectedAnswer = question.answers[ answerIndex ];
					totalScore += selectedAnswer.points || 0;
					answersSummary += `Frage: ${ question.questionText }\nAntwort: ${ selectedAnswer.text }\n\n`;
				}
			} );

			const isSuitable = totalScore >= ( evaluation.threshold || 0 );
			const result = isSuitable ? evaluation.suitableMessage : evaluation.unsuitableMessage;

			return {
				totalScore: totalScore,
				result: result,
				summary: answersSummary
			};
		}

		function showResult() {
			const scoreData = calculateScore();
			const resultMessage = `Ergebnis: ${ scoreData.result }\nGesamtpunkte: ${ scoreData.totalScore }\nJob: ${ jobTitle }\n\n${ scoreData.summary }`;

			questionContainer.style.display = 'none';
			resultContainer.style.display = 'block';

			// Wait for CF7 form to load, then set message field
			setTimeout( function() {
				const messageField = resultContainer.querySelector( 'textarea[name="senderMessage"]' );
				if ( messageField ) {
					messageField.value = resultMessage;
					console.log( 'Message set:', resultMessage );
				} else {
					console.error( 'CF7 message field not found' );
				}
			}, 100 );
		}

		// CF7 handles form submission itself, we just pre-fill the message

		// Initialize
		renderQuestion();
	} );
} );
